import type React from 'react';
import useStyles from './ImageHoverStyles';

interface ImageHoverProps {
  enlargeImageUrl: string;
  altText?: string;
  defaultWidth?: string | number;
  defaultHeight?: string | number;
  hoverWidth?: string | number;
  hoverHeight?: string | number;
}

const ImageHover: React.FC<ImageHoverProps> = (props) => {
  const classes = useStyles(props);

  return <img className={classes.imageContainer} src={props.enlargeImageUrl} alt={props.altText} />;
};

export default ImageHover;
